// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","leftBlock":"Header_leftBlock__fVrlb","iconWrapper":"Header_iconWrapper__3gS-5","title":"Header_title__6yJ+e"};